import React, { useState, useRef } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Typography,
  IconButton,
  Button,
  InputBase,
  Select,
  MenuItem,
  Menu,
  Pagination,
  TablePagination,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CustomText, { textStyles } from "../../../../components/CustomText";
import arrow from "../../../../assets/arrow.svg";
import invited from "../../../../assets/Dashboard/invited.svg";
import tablefilter from "../../../../assets/tablefilter.svg";
import AddCompanyDrawer from '../InvitedClients/AddClientsDrawer';
// import InviteDetails from '../InvitedClients/InvitedClientsDetail';
import ClientsRequestDetails from './ClientRequestDetails';
import request from "../../../../assets/Dashboard/request.svg";
import ExportClientRequestsPDF from './RequestPDf';
import { pdf } from '@react-pdf/renderer';
import { CircularProgress } from '@mui/material';
import FilterDrawer from "./FilterDrawer";
import StatusDropdown from '../../../../components/StatusDropdown';
import ExportDropdown from '../../../../components/ExportDropdown';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import NorthIcon from '@mui/icons-material/North'; // Ascending
import SouthIcon from '@mui/icons-material/South';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { BASE_URL } from "../../../../components/BaseUrl";
import { decryptToken } from "../../../../Utlis/Encryption";
import { toast, Toaster } from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import back from "../../../../assets/back.svg";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import emptyscreen from "../../../../assets/Dashboard/emptyscreen.svg";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowStatusDropdown from '../../../../components/ArrowStatusDropdown';
import ExportClientRequestsExcel from './RequestExcel';
import ClientsRequestsPins from './RequetedClientsPins';
import RequestedClientsPins from './RequetedClientsPins';
import { convertUTCToLocalDateTime } from "../../../../components/dateTime";
const ClientsRequests = () => {
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const rowsPerPage = 6;
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const fromDashboard = location.state?.fromDashboard || false;
  const [statusUpdating, setStatusUpdating] = useState(null);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const handleSelect = (id) => {
    setSelected(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const handleChangePage = (_, newPage) => setPage(newPage);

  const HaederStyles = {
    color: "#44546F",
    fontSize: "12px",
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 600,

  };
  const DataStyles = {
    color: "#172B4D",
    fontSize: "12px",
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 400,
    whiteSpace: 'nowrap', // ✅ Prevent text wrap

    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loadingExport, setLoadingExport] = useState(false);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [filters, setFilters] = useState({
    subscription_plan: '',
    subscription_status: '',
    status: '',
    verification_status: '',
    start_date: '',
    end_date: ''
  });

  const INITIAL_FILTERS = {
    subscription_plan: '',
    subscription_status: '',
    status: '',
    verification_status: '',
    start_date: '',
    end_date: ''
  };

  const statusButtonStyles = {
    active: { backgroundColor: '#4BCE97', color: '#164B35' },
    inactive: { backgroundColor: ' #F87168', color: '#5D1F1A' },
    requested: { backgroundColor: '#F5CD47', color: '#533F04' },
    invited: { backgroundColor: '#579DFF', color: '#09326C' },
    verified: { backgroundColor: '#2196F3', color: '#0D47A1' },
    rejected: { backgroundColor: '#D32F2F', color: '#FFFFFF' },
    pending: { backgroundColor: '#F5CD47', color: '#533F04' },
  };

  const [tableRows, setTableRows] = useState([]);
  const [originalRows, setOriginalRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const columns = [
    { key: 'id', label: t("ClientsRequests.columns.id") },
    { key: 'admin', label: t("ClientsRequests.columns.admin") },
    { key: 'company', label: t("ClientsRequests.columns.company") },
    { key: 'country', label: t("ClientsRequests.columns.country") },
    { key: 'active', label: t("activeUsers") },
    { key: 'Users', label: t("maxUsers") },
    { key: 'email', label: t("ClientsRequests.columns.email") },
    { key: 'subscription', label: t("subscriptionPlan") },
    { key: 'subscriptionStatus', label: t('subscriptionStatus') },

    { key: 'status', label: t("ClientsRequests.columns.status") },
    { key: 'verificationStatus', label: t("invites.columns.verificationStatus") },
    { key: 'created_at', label: t("DateTime") },
    { key: 'subscriptionPeriod', label: t("subscriptionPeriod") },
    { key: 'trialPeriod', label: t("trialPeriod") },
    { key: 'action', label: t("ClientsRequests.columns.action") }
  ];
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });
  const [sortLoading, setSortLoading] = useState(false);
  const [tableProcessing, setTableProcessing] = useState(false);
  const [firstLoadDone, setFirstLoadDone] = useState(false);
  const filteredRows = tableRows;

  const paginatedRows = filteredRows;
  const allSelected = tableRows.length > 0 && selected.length === tableRows.length;
  const isIndeterminate = selected.length > 0 && !allSelected;

  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const planNameMap = {
    attendance_yearly: "Attendance Yearly",
    attendance_monthly: "Attendance Monthly",
    full_monthly: "Full Monthly",
    full_yearly: "Full Yearly",
  };
     const formatRange = (start, end) => {
      if (!start && !end) return "-";
      const format = (d) => d ? convertUTCToLocalDateTime(d, { formatOptions: { day: '2-digit', month: 'short', year: 'numeric' } }) : "-";
      return `${format(start)} - ${format(end)}`;
    };
  const fetchRequestedCompanies = async (
    isSorting = false,
    keyword = '',
    appliedFilters = {}
  ) => {
    const isInitialLoad = !firstLoadDone;

    if (isInitialLoad) {
      setLoading(true);
    } else {
      setTableProcessing(true);
    }

    const queryParams = new URLSearchParams({
      page: page + 1,
      limit: rowsPerPage,
      // sort_by: sortConfig.key || 'email',
      sort_by: sortConfig.key || 'created_at',
      sort_order: sortConfig.direction?.toUpperCase() || 'DESC',
      status: appliedFilters.status || 'requested',
    });

    if (keyword) {
      queryParams.append('search', keyword);
    }

    if (appliedFilters.subscription_plan) {
      queryParams.append('subscription_plan', appliedFilters.subscription_plan);
    }

    if (appliedFilters.subscription_status) {
      queryParams.append('subscription_status', appliedFilters.subscription_status);
    }

    if (appliedFilters.verification_status && appliedFilters.verification_status !== 'all') {
      queryParams.append('verification_status', appliedFilters.verification_status);
    }

    if (appliedFilters.start_date) {
      queryParams.append('start_date', appliedFilters.start_date);
    }

    if (appliedFilters.end_date) {
      queryParams.append('end_date', appliedFilters.end_date);
    }
    if (appliedFilters.trial_end_date_from)
      queryParams.append("trial_end_date_from", appliedFilters.trial_end_date_from);

    if (appliedFilters.trial_end_date_to)
      queryParams.append("trial_end_date_to", appliedFilters.trial_end_date_to);

    if (appliedFilters.subscription_start_date_from)
      queryParams.append(
        "subscription_start_date_from",
        appliedFilters.subscription_start_date_from
      );

    if (appliedFilters.subscription_start_date_to)
      queryParams.append(
        "subscription_start_date_to",
        appliedFilters.subscription_start_date_to
      );
 
    const url = `${BASE_URL}/company-admins?${queryParams.toString()}`;
    console.log("📡 Requested Clients API:", url);

    try {
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const result = await res.json();
      if (!result.error && result.data?.company_admins) {
        let admins = result.data?.company_admins;

        const parsed = admins.map((admin) => {
          let cleanedSubscription;
          try {
            if (typeof admin.subscription_plan === 'string') {
              const parsed = JSON.parse(admin.subscription_plan);
              cleanedSubscription =
                typeof parsed === 'object' ? Object.keys(parsed)[0] || 'N/A' : admin.subscription_plan;
            } else if (typeof admin.subscription_plan === 'object') {
              cleanedSubscription = Object.keys(admin.subscription_plan)[0] || 'N/A';
            } else {
              cleanedSubscription = admin.subscription_plan || 'N/A';
            }
          } catch {
            cleanedSubscription = admin.subscription_plan || 'N/A';
          }

          return {
            id: admin.id,
            admin: admin.full_name,
            email: admin.email,
            company: admin.company_name,
            country: admin.country,
            subscription: planNameMap[admin.subscription_plan] || cleanedSubscription,
            subscriptionStatus: admin.subscription_status,
            status: (admin.status || '').toLowerCase(),
            verificationStatus: (admin.verification_status || '').toLowerCase(),
            created_at: admin.created_at,
            subscriptionPeriod: { start: admin.subscription_start_date, end: admin.subscription_end_date },
            trialPeriod: { start: admin.trial_start_date, end: admin.trial_end_date },
            active: admin.current_employees,
            Users: admin.max_employees,
            businessEmail: admin.business_email,
          };
        });

        setTableRows(parsed);
        setOriginalRows(parsed);
        setTotalPages(result.data.pagination.pages);
      } else {
        toast.error(result.message || 'Failed to fetch data');
      }
    } catch (err) {
      console.error("API fetch error:", err);
      toast.error("Something went wrong while fetching data.");
    } finally {
      // isSorting ? setSortLoading(false) : setLoading(false);
      setLoading(false);
      setTableProcessing(false);
      setFirstLoadDone(true);
    }
  };
  const isFilterApplied = Object.values(filters).some(f => f && f !== '');

  // useEffect(() => {
  //   fetchRequestedCompanies();
  // }, [page]);
  useEffect(() => {
    const delay = setTimeout(() => {
      fetchRequestedCompanies(false, searchTerm, filters);
    }, 500);
    return () => clearTimeout(delay);
  }, [page, searchTerm, filters]);
  const fieldMap = {
    admin: 'full_name',
    Users: 'max_employees',
    date: 'created_at',
    subscription: 'subscription_plan',
  };

  // const handleSort = (columnKey) => {
  //   const direction =
  //     sortConfig.key === columnKey && sortConfig.direction === 'asc' ? 'desc' : 'asc';

  //   const backendKey = fieldMap[columnKey] || columnKey;
  //   setSortConfig({ key: backendKey, direction });
  //   fetchRequestedCompanies(true);
  // };
  const handleSort = (columnKey) => {
    const direction =
      sortConfig.key === columnKey && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key: columnKey, direction });
    fetchRequestedCompanies(true);
  };
  const statusValues = ['active', 'inactive', 'invited', 'requested'];

  const statusOptions = statusValues.map((value) => ({
    label: t(`statusOptions.${value}`),
    value,
  }));

  const handleStatusUpdate = async (status) => {
    if (selected.length === 0) {
      toast.error("No companies selected");
      return;
    }

    setStatusUpdating(status);

    const rawEncryptedToken = localStorage.getItem("token");
    const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

    const payload = {
      company_admin_ids: selected,
      status: status,
      verification_status: 'verified',
    };

    try {
      const res = await fetch(`${BASE_URL}/company-admins/status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();
      if (result.error === false) {
        toast.success(result.message || `Status updated to "${status}"`);

        const updated = tableRows.map((row) => {
          if (selected.includes(row.id)) {

            let cleanedSubscription;
            try {
              if (typeof row.subscription === 'string') {
                const parsed = JSON.parse(row.subscription);
                cleanedSubscription = typeof parsed === 'object'
                  ? Object.keys(parsed)[0] || 'N/A'
                  : row.subscription;
              } else if (typeof row.subscription === 'object') {
                cleanedSubscription = Object.keys(row.subscription)[0] || 'N/A';
              } else {
                cleanedSubscription = row.subscription || 'N/A';
              }
            } catch {
              cleanedSubscription = row.subscription || 'N/A';
            }

            return {
              ...row,
              status,
              subscription: cleanedSubscription,
            };
          }
          return row;
        });

        setTableRows(updated);
        setSelected([]);
      } else {
        toast.error(result.message || "Failed to update status");
      }
    } catch (err) {
      console.error("Status update failed:", err);
      toast.error("Something went wrong while updating status.");
    } finally {
      setStatusUpdating(null);
    }
  };
  const [verifyingId, setVerifyingId] = useState(null);
  const handleVerificationStatusUpdate = async (verificationStatus, id) => {
    if (!id) {
      toast.error("No ID selected.");
      return;
    }
    setVerifyingId(id);
    const payload = {
      company_admin_ids: [id],
      status: tableRows.find(row => row.id === id)?.status || 'invited', // keep current status
      verification_status: verificationStatus,
    };

    const url = `${BASE_URL}/company-admins/status`;

    try {
      const res = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (result.error === false) {
        toast.success(`Verification status updated to "${verificationStatus}"`);

        const updated = [...tableRows];
        const index = updated.findIndex(row => row.id === id);
        if (index !== -1) {
          updated[index].verificationStatus = verificationStatus;
          setTableRows(updated);
        }
      } else {
        toast.error(result.message || "Failed to update verification status");
      }
    } catch (err) {
      console.error("❌ Error in verification update:", err);
      toast.error("Something went wrong while updating verification status.");
    }
    finally {
      setVerifyingId(null); // End loader
    }
  };


  const menuAnchorsRef = useRef({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRowId, setMenuRowId] = useState(null);


  const handleViewClick = async () => {
    if (!menuRowId) return;

    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/company-admins/${menuRowId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const json = await res.json();
      if (!json.error && json.data?.company_admin) {
        setSelectedRow(json.data.company_admin);
        setAnchorEl(null);      // ✅ Close menu
        setMenuRowId(null);     // ✅ Clear selected row ID
      } else {
        toast.error("Failed to fetch company admin details");
      }
    } catch (err) {
      toast.error("Error fetching details");
    } finally {
      setLoading(false);
    }
  };

  const handleMessagesClick = () => {
    if (!menuRowId) return;

    const selectedCompanyAdmin = tableRows.find(row => row.id === menuRowId);
    if (selectedCompanyAdmin) {
      navigate('/messages', {
        state: {
          openChatWith: {
            id: selectedCompanyAdmin.id,
            name: selectedCompanyAdmin.admin,
            email: selectedCompanyAdmin.email,
          },
          chatType: 'company_admin'
        }
      });
    }
    setAnchorEl(null);
  };


  // true if any filter set

  const clearFilters = () => {
    const clearedFilters = {
      subscription_plan: '',
      subscription_status: '',
      status: '',
      verification_status: '',
      start_date: '',
      end_date: ''
    };
    setFilters(clearedFilters);
    setPage(0); // reset pagination if needed
  };


  const fetchAllRequestedCompanies = async () => {
    const queryParams = new URLSearchParams({
      no_pagination: "true",
      status: filters.status || "requested",
      sort_by: sortConfig.key || "created_at",
      sort_order: sortConfig.direction?.toUpperCase() || "DESC",
    });

    if (searchTerm) queryParams.append("search", searchTerm);
    if (filters.subscription_plan) {
      queryParams.append("subscription_plan", filters.subscription_plan);
    }
    if (filters.subscription_status) {
      queryParams.append("subscription_status", filters.subscription_status);
    }
    if (filters.start_date) {
      queryParams.append("start_date", filters.start_date);
    }
    if (filters.end_date) {
      queryParams.append("end_date", filters.end_date);
    }

    const url = `${BASE_URL}/company-admins?${queryParams.toString()}`;
    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const result = await res.json();
    if (result.error) {
      toast.error(result.message || "Failed to fetch client requests");
      return [];
    }

    const admins = result?.data?.company_admins || [];

    return admins.map((admin) => {
      let cleanedSubscription;
      try {
        if (typeof admin.subscription_plan === "string") {
          const parsed = JSON.parse(admin.subscription_plan);
          cleanedSubscription =
            typeof parsed === "object"
              ? Object.keys(parsed)[0] || "N/A"
              : admin.subscription_plan;
        } else if (typeof admin.subscription_plan === "object") {
          cleanedSubscription = Object.keys(admin.subscription_plan)[0] || "N/A";
        } else {
          cleanedSubscription = admin.subscription_plan || "N/A";
        }
      } catch {
        cleanedSubscription = admin.subscription_plan || "N/A";
      }

      return {
        id: admin.id,
        admin: admin.full_name,
        email: admin.email,
        company: admin.company_name,
        country: admin.country,
        subscription: cleanedSubscription,
        status: (admin.status || "").toLowerCase(),
        verificationStatus: (admin.verification_status || "").toLowerCase(),
        created_at: new Date(admin.created_at).toLocaleString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
        Users: admin.max_employees,
      };
    });
  };


  const [statusUpdatingId, setStatusUpdatingId] = useState(null);

  const handleStatusUpdateSingle = async (id, status) => {
    const payload = {
      company_admin_ids: [id],
      status,
      verification_status: 'verified',
    };

    try {
      const res = await fetch(`${BASE_URL}/company-admins/status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (!result.error) {
        toast.success(`Status updated to "${status}"`);
      } else {
        toast.error(result.message || "Failed to update status");
      }

    } catch (err) {
      console.error("❌ Single update error:", err);
      toast.error("Something went wrong while updating status.");
    }
  };

  const getStatusConfig = (currentStatus) => {
    switch (currentStatus?.toLowerCase()) {
      case "active":
        return {
          showArrow: true,
          options: ["Inactive"],
          disabled: false,
        };

      case "invited":
      case "requested":
        return {
          showArrow: true,
          options: ["Active", "Inactive"],
          disabled: false,
        };

      case "inactive":
        return {
          showArrow: true,
          options: ["Active"],
          disabled: false,
        };

      default:
        return {
          showArrow: false,
          options: [],
          disabled: true,
        };
    }
  };

  const getVerificationConfig = (currentStatus) => {
    switch (currentStatus?.toLowerCase()) {
      case "pending":
        return {
          showArrow: true,
          options: ["verified", "rejected"],
          disabled: false,
        };

      case "verified":
      case "rejected":
      default:
        return {
          showArrow: false,
          options: [],
          disabled: true,
        };
    }
  };
  const mapFilters = {
    verification_status: filters.verification_status,
    start_date: filters.start_date,
    end_date: filters.end_date,
    country: filters.country,
    state: filters.province,
    city: filters.city,
    trial_end_date_from: filters.trial_end_date_from,
    trial_end_date_to: filters.trial_end_date_to,

    subscription_start_date_from: filters.subscription_start_date_from,
    subscription_start_date_to: filters.subscription_start_date_to,
    subscription_status: filters.subscription_status,

  };
  return (
    <Box sx={{ py: 2, px: 1 }}>

      <Toaster />
      {fromDashboard && !selectedRow && (
        <Box
          sx={{
            border: '1px solid #E4E6EF',
            borderRadius: 2,
            px: 2,
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            minHeight: 55,
            mb: 2
          }}
        >
          <Box
            sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
            onClick={() => navigate(-1)}
          >
            <img src={back} style={{ width: 30, height: 30 }} />
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 500,
                fontSize: '14px',
                color: '#626F86',
                textAlign: 'center'
              }}
            >
              {t('clientsTrialDetails.back')}
            </CustomText>
          </Box>
        </Box>
      )}

      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'calc(100vh - 120px)',
          }}
        >
          <CircularProgress sx={{ color: '#006EC2' }} size={40} thickness={4} />
        </Box>
      ) : selectedRow ? (
        <ClientsRequestDetails selectedRow={selectedRow} onClose={() => setSelectedRow(null)} />
      ) : (
        <>

          <Box sx={{ mb: 2, }}>
            <RequestedClientsPins selectedClientId={selectedClientId}
              onClearClientId={() => setSelectedClientId(null)}
              filters={mapFilters}
              page={page}
              limit={rowsPerPage} />
          </Box>

          <Box sx={{ backgroundColor: '#fff', borderRadius: 2, py: 2, border: '1px solid #E4E6EF' }}>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                px: 2,
                mb: 2,
                flexWrap: 'wrap',
                rowGap: 1,
              }}
            >

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CustomText sx={{ ...textStyles.h1, fontWeight: 600, fontSize: "18px", color: "#003149", textAlign: "left" }}>
                  {t("ClientsRequests.title")}
                </CustomText>
                {tableProcessing && (
                  <CircularProgress
                    size={18}
                    thickness={4}
                    sx={{ color: '#006EC2' }}
                  />
                )}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  flexWrap: 'wrap',
                  flexGrow: 1,
                  justifyContent: selected.length === 0 ? 'center' : 'flex-end',
                }}
              >
                {selected.length > 0 ? (


                  statusOptions.map(({ label, value }) => (
                    <Button
                      key={label}
                      onClick={() => handleStatusUpdate(value)}
                      variant="contained"
                      size="small"
                      sx={{
                        px: 2,
                        height: 34,
                        fontSize: 13,
                        fontWeight: 400,
                        fontFamily: 'Poppins, sans-serif',
                        borderRadius: '4px',
                        textTransform: 'none',
                        backgroundColor: statusButtonStyles[value]?.backgroundColor,
                        color: statusButtonStyles[value]?.color,
                        '&:hover': {
                          backgroundColor: statusButtonStyles[value]?.backgroundColor,
                          opacity: 0.9,
                        },
                      }}
                    >
                      {statusUpdating === value && (
                        <CircularProgress
                          size={16}
                          thickness={4}
                          sx={{ color: statusButtonStyles[value]?.color, mr: 1 }}
                        />
                      )}
                      {label}
                    </Button>
                  ))
                ) : (

                  <>
                    <Box
                      sx={{
                        mx: 'auto',
                        px: 0.5,
                        py: 0.2,
                        borderRadius: 1,
                        height: 34,
                        border: '2px solid #091E4224',
                        display: 'flex',
                        alignItems: 'center',
                        minWidth: 250,

                      }}

                    >
                      <InputBase

                        placeholder={t("adminNameEmail")}
                        sx={{
                          ml: 0.5,
                          fontSize: 15,
                          letterSpacing: '1px',
                          color: '#939393',
                          fontWeight: 500,
                          width: '100%',
                        }}
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setPage(0);
                        }}
                      />
                      <SearchIcon sx={{ fontSize: 22, color: '#888', mr: 0.5 }} />
                    </Box>
                    <ExportDropdown
                      onDownloadPDF={async () => {
                        const allData = await fetchAllRequestedCompanies(); // 👈 fetch all filtered results
                        const blobStream = pdf(<ExportClientRequestsPDF data={allData} />).toBlob();
                        blobStream.then((blob) => {
                          const link = document.createElement("a");
                          link.href = URL.createObjectURL(blob);
                          link.download = `Client_Requests_${new Date()
                            .toISOString()
                            .slice(0, 10)}.pdf`;
                          link.click();
                        });
                      }}
                      onDownloadExcel={async () => {
                        const allData = await fetchAllRequestedCompanies(); // 👈 fetch all filtered results
                        ExportClientRequestsExcel(allData);
                      }}
                    />

                    {isFilterApplied ? (
                      <Box
                        sx={{
                          position: "relative",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 34,
                          height: 34,
                          borderRadius: 1,
                          bgcolor: "#006EC2", // blue background
                        }}
                      >
                        {/* Filter Icon */}
                        <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

                        {/* Cross Badge */}
                        <IconButton
                          size="small"
                          onClick={clearFilters} // 👉 your clear function
                          sx={{
                            position: "absolute",
                            top: -6,
                            right: -6,
                            bgcolor: "white",
                            width: 18,
                            height: 18,
                            border: "1px solid #C4C4C4",
                            "&:hover": { bgcolor: "#f5f5f5" },
                          }}
                        >
                          <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
                        </IconButton>
                      </Box>
                    ) : (
                      <IconButton
                        onClick={() => setFilterDrawerOpen(true)}
                        sx={{
                          border: "1px solid #C4C4C4",
                          borderRadius: 1,
                          width: 34,
                          height: 34,
                          backgroundColor: "white",
                          color: "#5E5C5C",
                          "&:hover": { backgroundColor: "#F2F2F2" },
                        }}
                      >
                        <FilterAltIcon sx={{ fontSize: 22 }} />
                      </IconButton>
                    )}
                  </>
                )}
              </Box>
            </Box>


            <Box
              sx={{
                width: '100%',
                overflowX: 'auto',
                // display: 'block', // ⬅️ Ensure it's not flex
                paddingBottom: 1,
              }}
            >
              <Box sx={{}}>
                <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                  <Table size="small">
                    <TableHead sx={{
                      whiteSpace: 'nowrap', // ✅ Prevent text wrap

                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}    >

                      <TableRow>

                        {columns.map((col) => (
                          <TableCell
                            key={col.key}
                            sx={{ ...HaederStyles, py: '6px', px: '2px', textAlign: col.key === 'email' || col.key === 'status' ? 'center' : 'left' }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: col.key === 'action' ? 'flex-start' : 'center' }}>
                              {col.label}
                              {col.key !== 'action' && (
                                <IconButton size="small" onClick={() => handleSort(col.key)}>
                                  {sortConfig.key === col.key && sortConfig.direction === 'asc' ? (
                                    <NorthIcon sx={{ fontSize: '12px' }} />
                                  ) : (
                                    <SouthIcon sx={{ fontSize: '12px' }} />
                                  )}
                                </IconButton>
                              )}
                            </Box>
                          </TableCell>
                        ))}
                      </TableRow>

                    </TableHead>


                    <TableBody>
                      {paginatedRows.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={columns.length + 1}>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                height: 300,
                              }}
                            >
                              <img src={emptyscreen} alt="No Data" style={{ width: 200 }} />
                              <CustomText
                                sx={{
                                  ...textStyles.h1,
                                  fontWeight: 500,
                                  fontSize: "16px",
                                  color: "#003149",
                                  pt: 1,
                                }}
                              >
                                {t("empty.no_user")}
                              </CustomText>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ) : (
                        paginatedRows.map((row, index) => {
                          /* ================= STATUS CONFIG ================= */
                          const {
                            showArrow: statusShowArrow,
                            options: statusOptionsFiltered,
                            disabled: statusDisabled,
                          } = getStatusConfig(row.status);

                          /* ============== VERIFICATION CONFIG ============== */
                          const {
                            showArrow: verificationShowArrow,
                            options: verificationOptions,
                            disabled: verificationDisabled,
                          } = getVerificationConfig(row.verificationStatus);

                          return (
                            <TableRow
                              key={row.id}
                              hover
                              onClick={() => setSelectedClientId(row.id)}
                              sx={{ cursor: "pointer" }}
                            >
                              {/* ID */}
                              <TableCell sx={{ ...DataStyles, pl: 1 }}>
                                {row.id}
                              </TableCell>

                              {/* ADMIN */}
                              <TableCell sx={{ ...DataStyles }}>
                                <CustomText sx={{ fontSize: 14, fontWeight: 500 }}>
                                  {row.admin || "-- "}
                                </CustomText>
                                <CustomText sx={{ fontSize: 12, color: "#5A5A5A" }}>
                                  {row.email || "-- "}
                                </CustomText>
                              </TableCell>

                              {/* COMPANY */}
                              <TableCell sx={{ ...DataStyles }}>{row.company || "-- "}</TableCell>

                              {/* COUNTRY */}
                              <TableCell sx={{ ...DataStyles }}>{row.country || "-- "}</TableCell>

                              {/* ACTIVE USERS */}
                              <TableCell sx={{ ...DataStyles }}>{row.active || "-- "}</TableCell>

                              {/* MAX USERS */}
                              <TableCell sx={{ ...DataStyles }}>{row.Users || "-- "}</TableCell>

                              {/* BUSINESS EMAIL */}
                              <TableCell sx={{ ...DataStyles }}>{row.businessEmail || "-- "}</TableCell>

                              {/* SUBSCRIPTION */}
                              <TableCell sx={{ ...DataStyles }}>
                                {Array.isArray(row.subscription)
                                  ? row.subscription.join(", ")
                                  : String(row.subscription)?.replace(/[\[\]{}"]/g, "")}
                              </TableCell>

                              <TableCell sx={{ ...DataStyles, width: 120, textTransform: "capitalize" }}>
                                {row?.subscriptionStatus?.replace(/_/g, " --")}
                              </TableCell>
                              {/* ================= STATUS ================= */}
                              <TableCell sx={{ ...DataStyles, textAlign: "center", width: 160 }}>
                                <Box
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 1,
                                    px: 0.6,
                                    py: 0.1,
                                    borderRadius: 1,
                                    backgroundColor:
                                      statusButtonStyles[row.status]?.backgroundColor,
                                    color: statusButtonStyles[row.status]?.color,
                                    pointerEvents: statusDisabled ? "none" : "auto",
                                    cursor: statusDisabled ? "default" : "pointer",
                                    opacity: statusDisabled ? 0.9 : 1,
                                  }}
                                >
                                  {statusUpdatingId === row.id && (
                                    <CircularProgress size={12} thickness={4} />
                                  )}

                                  <StatusDropdown
                                    currentStatus={row.status}
                                    showArrow={statusShowArrow}
                                    showError={false}
                                    statusOptions={statusOptionsFiltered}
                                    onChange={(newStatus) => {
                                      if (!statusOptionsFiltered.includes(newStatus)) return;

                                      setStatusUpdatingId(row.id);

                                      const updated = [...tableRows];
                                      updated[index].status = newStatus;
                                      setTableRows(updated);

                                      handleStatusUpdateSingle(
                                        row.id,
                                        newStatus.toLowerCase()
                                      ).finally(() => setStatusUpdatingId(null));
                                    }}
                                  />
                                </Box>
                              </TableCell>

                              {/* ============ VERIFICATION STATUS ============ */}
                              <TableCell sx={{ ...DataStyles, textAlign: "center", width: 160 }}>
                                <Box
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 1,
                                    px: 0.6,
                                    py: 0.1,
                                    borderRadius: 1,
                                    backgroundColor:
                                      statusButtonStyles[row.verificationStatus]
                                        ?.backgroundColor,
                                    color:
                                      statusButtonStyles[row.verificationStatus]?.color,
                                    pointerEvents: verificationDisabled ? "none" : "auto",
                                    cursor: verificationDisabled ? "default" : "pointer",
                                    opacity: verificationDisabled ? 0.9 : 1,
                                  }}
                                >
                                  {verifyingId === row.id && (
                                    <CircularProgress size={12} thickness={4} />
                                  )}

                                  <ArrowStatusDropdown
                                    currentStatus={row.verificationStatus}
                                    showArrow={verificationShowArrow}
                                    statusOptions={verificationOptions}
                                    onChange={(newStatus) => {
                                      if (!verificationOptions.includes(newStatus)) return;
                                      handleVerificationStatusUpdate(newStatus, row.id);
                                    }}
                                  />
                                </Box>
                              </TableCell>


                              {/* DATE */}
                              <TableCell sx={{ ...DataStyles }}>
                                {row.created_at ? convertUTCToLocalDateTime(row.created_at) : "-- "}
                              </TableCell>

                              <TableCell sx={{ ...DataStyles, width: 220 }}>
                                {row.subscriptionPeriod && typeof row.subscriptionPeriod === 'object'
                                  ? formatRange(row.subscriptionPeriod.start, row.subscriptionPeriod.end)
                                  : "-"}
                              </TableCell>
                              <TableCell sx={{ ...DataStyles, width: 220 }}>
                                {row.trialPeriod && typeof row.trialPeriod === 'object'
                                  ? formatRange(row.trialPeriod.start, row.trialPeriod.end)
                                  : "-"}
                              </TableCell>



                              {/* ACTION */}
                              <TableCell>
                                <IconButton
                                  ref={(el) => {
                                    if (el) menuAnchorsRef.current[row.id] = el;
                                  }}
                                  onClick={() => {
                                    setAnchorEl(menuAnchorsRef.current[row.id]);
                                    setMenuRowId(row.id);
                                  }}
                                >
                                  <MoreVertIcon fontSize="small" />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      )}
                    </TableBody>




                  </Table>

                </TableContainer>
              </Box>
            </Box>
            <Menu
              sx={{ fontSize: "15px", boxShadow: "none" }}
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              PaperProps={{
                sx: {

                },
              }}
              MenuListProps={{
                sx: {
                  paddingY: 0,
                },
              }}
            >
              <MenuItem onClick={handleViewClick} sx={{
                fontSize: "14px",
                fontFamily: 'Poppins, sans-serif',
              }}>{t("common.view")}</MenuItem>

              <MenuItem onClick={handleMessagesClick} sx={{
                fontSize: "14px",
                fontFamily: 'Poppins, sans-serif',
              }}>{t("messages")}</MenuItem>


            </Menu>

            <Box sx={{ display: 'flex', flexWrap: "wrap", justifyContent: 'center', mt: 2 }}>
              <Pagination
                count={totalPages}
                page={page + 1}
                onChange={(e, value) => setPage(value - 1)}
                shape="rounded"
                color="primary"
                size="small"
                sx={{
                  '& .MuiPaginationItem-root': {
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: 13,
                    fontWeight: 500,
                  },
                  '& .Mui-selected': {
                    backgroundColor: '#E9F3FF',
                    color: '#006EC2',
                  },
                }}
              />
            </Box>
          </Box>
        </>
      )}
      <AddCompanyDrawer open={openDrawer} onClose={() => setOpenDrawer(false)} />

      <FilterDrawer
        open={filterDrawerOpen}
        onClose={() => setFilterDrawerOpen(false)}
        filters={filters}
        setFilters={setFilters}
        onApplyFilters={(updatedFilters) => {
          console.log("📤 Applied filters:", updatedFilters);
          setFilters(updatedFilters);
          setPage(0);
          setFilterDrawerOpen(false);
        }}
      />

    </Box>
  );
};

export default ClientsRequests;








